// extracted by mini-css-extract-plugin
export default {"menu-col":"menu-col_wcmpk","menu-card":"menu-card_VpC5q","menu-icon":"menu-icon_XnLuA"};